:host {
  animation: fadeIn 250ms 250ms forwards;
  opacity: 0;
}

.spinner {
  --size: 32px;

  max-height: var(--size);
  max-width: var(--size);
  display: inline-block;
  height: 100%;
  position: relative;
  width: 100%;
  animation: spin 2s linear infinite;
}

.s {
  --size: 24px;
}

.l {
  --size: 48px;
}

.xl {
  --size: 64px;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

@keyframes spin {
  to {
    transform: rotate(1turn);
  }
}
